import { SocketStock } from "@/helpers/models/stock/socket_stock.model";
import { onMounted, onUnmounted, ref } from "vue";
import { useStockSocket } from "./stock_socket.composable";
import { PRICE_SOURCE } from "@/helpers/live-price.helpers";

const { getDataByStockId, checkStockExistence } = useStockSocket();

export const useSocketStockData = (stockInfo: any) => {
  const stockData = ref<SocketStock>();
  let pollTimer: ReturnType<typeof setTimeout> | null = null;

  const resolvePropsWithStore = (obj: any) => {
    if (!obj?._id) return obj;
    const storeRow = getDataByStockId(obj._id);
    if (storeRow?.[PRICE_SOURCE] === "nats" && storeRow.price != null) {
      return {
        ...obj,
        price: storeRow.price,
        changesPercentage: storeRow.changesPercentage,
        change: storeRow.change,
      };
    }
    if (storeRow?.price != null && obj.price == null) {
      return {
        ...obj,
        price: storeRow.price,
        changesPercentage: storeRow.changesPercentage,
        change: storeRow.change,
      };
    }
    return obj;
  };

  onMounted(() => {
    updateStockInfoObject(stockInfo);
  });

  onUnmounted(() => {
    if (pollTimer) clearTimeout(pollTimer);
  });

  const updateStockInfoObject = (obj: any) => {
    stockInfo = obj;
    if (!stockInfo) return;

    stockData.value = SocketStock.convertToStockObject(
      stockData.value,
      resolvePropsWithStore(stockInfo)
    );

    if (stockInfo._id) {
      checkStockExistence(stockInfo._id, stockData.value?.fiveDayTrend != undefined);
      updateStockObject();
    }
  };

  const updateStockObject = () => {
    const id = stockData.value?._id;
    if (!id) return;

    const data = getDataByStockId(id);
    if (data) {
      SocketStock.copy(stockData.value!, data);
    }

    pollTimer = setTimeout(updateStockObject, 300);
  };

  return {
    updateStockInfoObject,
    stockData,
  };
};
